<template>
  <div 
    v-if="visible" 
    class="latex-preview-tooltip"
    :style="{ 
      left: position.x + 'px', 
      top: position.y + 'px' 
    }"
  >
    <div class="preview-content">
      <div v-if="renderedHtml" v-html="renderedHtml" class="rendered-formula"></div>
      <div v-else-if="formula" class="error-message">
        公式渲染失败: {{ formula }}
      </div>
      <div v-else class="error-message">无公式内容</div>
    </div>
  </div>
</template>

<script>
import katex from 'katex'
import 'katex/dist/katex.min.css'

export default {
  name: 'LatexPreview',
  data() {
    return {
      visible: false,
      formula: '',
      renderedHtml: '',
      position: { x: 0, y: 0 },
      displayMode: false
    }
  },
  methods: {
    show(formula, x, y, displayMode = false) {
      this.formula = formula
      this.displayMode = displayMode
      this.position = { x, y }
      
      try {
        this.renderedHtml = katex.renderToString(formula, {
          displayMode: displayMode,
          throwOnError: false
        })
      } catch (error) {
        this.renderedHtml = ''
      }
      
      this.visible = true
    },
    
    hide() {
      this.visible = false
      this.formula = ''
      this.renderedHtml = ''
    },
    
    updatePosition(x, y) {
      this.position = { x, y }
    }
  }
}
</script>

<style lang="scss" scoped>
.latex-preview-tooltip {
  position: fixed;
  z-index: 10000;
  background: white;
  border: 1px solid #e1e4e8;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  max-width: 500px;
  min-width: 200px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  animation: fadeInScale 0.15s ease-out;
  
  @keyframes fadeInScale {
    from {
      opacity: 0;
      transform: scale(0.9) translateY(-10px);
    }
    to {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
  }
  
  .preview-content {
    padding: 16px;
    text-align: center;
    background: white;
    border-radius: 6px;
    
    .rendered-formula {
      font-size: 20px;
      line-height: 1.6;
      color: #2c3e50;
      white-space: nowrap; // 不换行
      
      // 确保KaTeX样式不被覆盖
      ::v-deep .katex {
        font-size: 1.2em !important;
        font-family: KaTeX_Main, "Times New Roman", serif !important;
        
        .katex-html {
          display: inline-block !important;
        }
        
        .katex-mathml {
          display: none !important;
        }
        
      }
    }
    
    .error-message {
      color: #e74c3c;
      font-style: italic;
      font-size: 14px;
    }
  }
}

// 确保预览框在最顶层
.latex-preview-tooltip {
  pointer-events: auto;
}
</style>
